import { ModalCustom } from "components/ModalCustom";
import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Required } from "components/Required";
import FileUpload from "components/UploadArquivos";
import { CustomInput } from "components/CustomInput";
import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { IAtualizarLote } from "../../../../../interface/IAtualizarLote";
import {
  Container,
  ContainerAvisoAtualize,
  ContainerInputs,
  ContainerTituloInput,
  IconeContainerAtencao,
  InfoContainer,
  TextContainer,
} from "./style";
import { FaExclamation, FaExclamationCircle } from "react-icons/fa";
import { useMaskInput } from "hooks/useMaskInput";

interface Props {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  numeroNfRecibo: string | number;
  dadosAtualizarLote: IAtualizarLote | null;
  setDadosAtualizarLote: (dados: IAtualizarLote | null) => void;
}

export function ModalEditarProcessoNfReciboValores({
  show,
  handleClose,
  onConfirm,
  numeroNfRecibo,
  dadosAtualizarLote,
  setDadosAtualizarLote,
}: Props) {
  const { mInputCoin } = useMaskInput();

  const onChangeValorNfRecibo = (valor: number) => {
    if (!dadosAtualizarLote) {
      return;
    }

    setDadosAtualizarLote({
      ...dadosAtualizarLote,
      valorNfRecibo: valor,
    });
  };
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={`Editar - Lote de pagamento ${numeroNfRecibo}`}
      centered
    >
      <ContainerAvisoAtualize>
        Atualize as informações do Recibo/NF emitido pelo fornecedor.
      </ContainerAvisoAtualize>
      <InfoContainer>
        <IconeContainerAtencao>
          <FaExclamationCircle />
        </IconeContainerAtencao>
        <TextContainer>
          Caso os dados não sejam atualizados, haverá divergências entre o valor
          dos custos do processo e o valor do Recibo/NF.
        </TextContainer>
      </InfoContainer>

      <Container>
        <ContainerInputs>
          <ContainerTituloInput>
            Nº Recibo / NF
            <Required />
          </ContainerTituloInput>

          <CustomInput
            type="text"
            placeholder="Informe o nº do recibo ou NF emitido pelo fornecedor"
            style={{ height: "2.2rem" }}
            value={dadosAtualizarLote?.numeroNfRecibo}
            onChange={(e) => {
              if (!dadosAtualizarLote) {
                return;
              }

              setDadosAtualizarLote({
                ...dadosAtualizarLote,
                numeroNfRecibo: e.target.value,
              });
            }}
          />
        </ContainerInputs>
        <ContainerInputs style={{ marginTop: 24 }}>
          <ContainerTituloInput>
            Valor total do recibo / NF
            <Required />
          </ContainerTituloInput>

          <CustomInput
            type="text"
            placeholder="Informe o valor do recibo ou NF emitido pelo fornecedor"
            style={{ height: "2.2rem" }}
            value={dadosAtualizarLote?.valorNfRecibo}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowRight" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            onChange={(e) => onChangeValorNfRecibo(mInputCoin(e))}
          />
        </ContainerInputs>
        <ContainerInputs style={{ marginTop: 24 }}>
          <ContainerTituloInput>
            Arquivo (PDF autorização)
            <Required />
          </ContainerTituloInput>

          <FileUpload
            onFileUpload={(file) => {
              if (!dadosAtualizarLote) {
                return;
              }

              setDadosAtualizarLote({
                ...dadosAtualizarLote,
                arquivo: file,
              });
            }}
            comMaxWidth={false}
            gapContainer="0"
            id="baixaManualInput"
            inputAccept=".png, .jpg, .jpeg, .pdf"
          />
        </ContainerInputs>
      </Container>

      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "8rem" }}
          outline
          variante="primary"
          onClick={handleClose}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton
          style={{ width: "8rem" }}
          type="submit"
          onClick={onConfirm}
          disabled={
            !dadosAtualizarLote ||
            !dadosAtualizarLote.arquivo ||
            !dadosAtualizarLote.numeroNfRecibo ||
            !dadosAtualizarLote.valorNfRecibo
          }
        >
          Salvar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
